export enum AppCode {
  Main = 'main-ui',
  About = 'about-ui',
  Products = 'products-ui',
}
